"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorage = void 0;
const react_1 = require("react");
const version_1 = require("../version");
const smap_1 = require("../smap");
const numberFormatter_1 = require("../numberFormatter");
const lodash_1 = __importDefault(require("lodash"));
const defaultState = {
    version: (0, version_1.VERSION)(),
    displayAmount: {},
    amountThatWeHave: {},
    assemblers: {},
    visible: {},
    storage: {},
    productionProgress: {},
    amountCreated: {},
    acknowledged: {},
    disabledRecipes: {},
    powerConsumptionProgress: {},
    timeSpentPlaying: 0,
    timeUnlockedAt: {},
    ticksSinceLastUIUpdate: 0,
    lastTickTimestamp: 0,
    lastUIUpdateTimestamp: 0,
    powerConsumptionState: {},
    productionState: {},
    hideAddButtons: {},
    numberFormatMode: numberFormatter_1.NumberFormat.SUFFIX,
};
function makeName(name) {
    return `idlefactory.${name}`;
}
function serializer(key, value) {
    if (typeof value === "number") {
        return Math.round(value * 1000) / 1000;
    }
    if (typeof value === 'bigint') {
        return `bigint=${value}`;
    }
    return value;
}
function deserializer(key, value) {
    if (typeof value === 'string' && value.startsWith('bigint=')) {
        const [, val] = value.split('=');
        return BigInt(val);
    }
    return value;
}
function getStorage() {
    const monoState = localStorage.getItem("state");
    if (monoState) {
        const existingStorage = {
            ...defaultState,
            ...JSON.parse(monoState),
        };
        return existingStorage;
    }
    else {
        const state = { ...defaultState };
        (0, smap_1.keys)(defaultState).forEach((k) => {
            const storage = localStorage.getItem(makeName(k));
            if (storage) {
                lodash_1.default.set(state, k, JSON.parse(storage, deserializer));
            }
        });
        return state;
    }
}
function loadAndCheckStorage() {
    const state = getStorage();
    if (state.version[0] != (0, version_1.VERSION)()[0]) {
        return defaultState;
    }
    return state;
}
function saveGame(state) {
    (0, smap_1.keys)(state).forEach((key) => {
        localStorage.setItem(makeName(key), JSON.stringify(state[key], serializer));
    });
    if (localStorage.getItem("state")) {
        localStorage.removeItem("state");
    }
}
function useLocalStorage() {
    const existingStorage = (0, react_1.useMemo)(loadAndCheckStorage, []);
    const resetGame = (0, react_1.useCallback)(() => {
        saveGame(defaultState);
        return defaultState;
    }, []);
    return {
        existingStorage,
        saveGame,
        resetGame,
    };
}
exports.useLocalStorage = useLocalStorage;
